import React, { Fragment, useState, useEffect } from 'react';
import {
  Box,
  CardMedia,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  Switch,
  TextField,
  Typography,
  InputAdornment,
  MenuItem,
  Button,
  FormHelperText
} from '@mui/material';
import { FacebookRounded, Instagram, WhatsApp, X, LinkedIn, KeyboardArrowLeft } from '@mui/icons-material';
import Colors from '../../../Assets/Styles/Colors';
import BreadCrumbs from '../../../Components/BreadCrumbs/BreadCrumbs';
import { OutlineInputField, InputField } from '../../../Components/Fields/TextFields';
import SelectField from '../../../Components/Fields/SelectField';
import { PrimaryButton } from '../../../Components/Buttons';
import { Close, PhotoLibrary } from '@mui/icons-material';
import styled from '@emotion/styled';
import { useForm } from 'react-hook-form';
import CategoriesServices from '../../../Api/AdBazar/Categories/CategoriesServices';
import { baseUrl } from '../../../../axios';
import AdleaksServices from '../../../Api/AdLeak/AdleaksServices';
import { useNavigate, useLocation } from 'react-router-dom';
import moment from 'moment';
import { ErrorToaster, SuccessToaster } from '../../../Components/Toaster/Toaster';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import axios from 'axios';
import "../Create AdBook/index.css"
import AddressForm from '../../../Components/AddressForm';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import useAuth from "../../../hooks/useAuth";

const CustomSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : Colors.primary,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));


function EditAdBook() {
  const socialData = [
    {
      _id: 1001,
      value: "f_link",
      name: "Facebook",
      icon: <FacebookRounded sx={{ color: Colors.primary }} />
    },
    {
      _id: 1002,
      value: "t_link",
      name: "Twitter",
      icon: <X sx={{ color: Colors.primary }} />
    },
    {
      _id: 1003,
      value: "l_link",
      name: "Linkedin",
      icon: <LinkedIn sx={{ color: Colors.primary }} />
    },
    {
      _id: 1004,
      value: "w_link",
      name: "Instagram",
      icon: <Instagram sx={{ color: Colors.primary }} />
    },
  ];

  const [image, setImage] = useState("");
  const [label, setLabel] = useState("Active");
  const [isChecked, setIsChecked] = useState(true);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState({ id: "", name: "" });
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSocial, setSelectedSocial] = useState({ id: "", name: "", value: "", icon: "" });
  const [socialMediaLink, setSocialMediaLink] = useState([]);
  const [link, setLink] = useState("");
  const [loading, setLoading] = useState(false);
  const [ckValue, setCkValue] = useState('');
  const [open, setOpen] = useState(false);
  const [addressData, setAddressData] = useState(null);
  const { isAdmin } = useAuth();
  const { register, handleSubmit, formState: { errors }, setValue, getValues } = useForm();

  const navigate = useNavigate();
  const { state } = useLocation();

  const handleFileUpload = async (file) => {
    const formData = new FormData();
    formData.append("image", file);
    try {
      const result = await CategoriesServices.uploadImage(formData);
      setImage(result?.data?.imageUrl)
    } catch (error) {
      console.log(error)
    }
  }

  const handleChecked = (e) => {
    setIsChecked(e.target.checked);
    setLabel(e.target.checked == true ? "Active" : "Inactive")
  }

  const submitForm = async (formData) => {
    const additionalLinks = socialMediaLink.reduce((acc, item) => {
      if (item.f_link) acc.f_link = item.f_link;
      if (item.t_link) acc.t_link = item.t_link;
      if (item.l_link) acc.l_link = item.l_link;
      if (item.w_link) acc.w_link = item.w_link;
      return acc;
    }, {});
    const obj = {
      title: formData?.AdBookTitle,
      category: selectedCategory?.id,
      image: image,
      date: selectedDate,
      content: ckValue,
      status: isChecked,
      additional: {
        ...additionalLinks,
        name: formData?.contactPerson,
        email: formData?.email,
        phone_num: formData?.phone,
        location: addressData?.address
      },
      type: "Adbook"
    }
    if (image == "") {
      ErrorToaster("Please select an image")
    } else {
      setLoading(true);
      try {
        const result = await AdleaksServices.updateAdLeaks(state?._id, obj);
        if (result?.responseCode == 200) {
          SuccessToaster(result?.message);
          navigate("/adbooks-list");
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  }

  const getAllCategories = async () => {
    try {
      const result = await CategoriesServices.getAllCategories("", 1, 100, "adbook");
      const filteredCategories = result?.data?.categories?.filter((item) => item.isActive == true);
      setCategories(filteredCategories);
      // console.log(result);
    } catch (error) {
      console.log(error);
    }
  }

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleSocialPlatform = (value) => {
    const selectedSocialPlatform = socialData.find(item => item.value == value);
    setSelectedSocial({
      id: selectedSocialPlatform._id,
      name: selectedSocialPlatform.name,
      value: selectedSocialPlatform.value,
      icon: selectedSocialPlatform.icon
    })

  }

  const handleLinkAdd = () => {
    const existingIndex = socialMediaLink.findIndex(item => item.name === selectedSocial.name);
    if (existingIndex !== -1) {
      // If link for selected platform already exists, update it
      const updatedSocialMediaLink = [...socialMediaLink];
      updatedSocialMediaLink[existingIndex][`${selectedSocial.value}`] = link;
      setSocialMediaLink(updatedSocialMediaLink);
    } else {
      // If link for selected platform doesn't exist, add it
      const obj = {
        [selectedSocial.value]: link,
        name: selectedSocial.name
      };
      setSocialMediaLink([...socialMediaLink, obj]);
    }
    setLink("")
  }

  const handleRemoveLink = (obj) => {
    const updatedSocialMediaLink = socialMediaLink.filter((item) => item.name !== obj.name);
    setSocialMediaLink(updatedSocialMediaLink);
  }

  const saveAddress = async (data) => {
    try {
      setOpen(false);
      setAddressData(data);
      setValue("address", data?.address);
    } catch (error) {
      console.log(error);
    }
  };

  const defaultData = () => {
    setValue("AdBookTitle", state?.title);
    setValue("contactPerson", state?.additional?.name);
    setValue("email", state?.additional?.email);
    setValue("phone", state?.additional?.phone_num);
    setValue("address", state?.additional?.location);
    setCkValue(state?.content);
    setSelectedDate(moment(state?.date));
    setIsChecked(state?.status);
    setSelectedCategory({ id: state?.category?._id, name: state?.category?.name });
    setValue("category", state?.category[0]?._id);
    setImage(state?.image);
    setAddressData({
      address: state?.additional?.location,
      latitude: state?.additional?.latitude,
      longitude: state?.additional?.longitude
    })
    const platformNameMapping = {
      f_link: "Facebook",
      t_link: "Twitter",
      l_link: "LinkedIn",
      w_link: "Instagram"
    };
    const additionalLinksArray = Object.keys(state?.additional)?.map(key => ({
      name: platformNameMapping[key], // Get platform name from mapping object
      [key]: state?.additional[key] // Assign link to platform key
    }));
    setSocialMediaLink(additionalLinksArray)
  }

  const handleEditorReady = (editor) => {
    console.log('Editor is ready to use!', editor);
  };

  const handleEditorChange = (event, editor) => {
    console.log(event);
    console.log(editor);
    setCkValue(editor.getData());
  };

  function uploadAdapter(loader) {
    return {
      upload: () => {
        return loader.file.then(file => {
          return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("image", file);

            axios
              .post("https://adstreet.mangotech-api.com/api/ad/uploadImage", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Bearer ${localStorage.getItem("token")}`
                }
              })
              .then(response => {
                resolve({ default: `https://adstreet.mangotech-api.com${response.data.data.imageUrl}` });
              })
              .catch(error => {
                reject(error);
              });
          });
        });
      }
    };
  }

  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = loader => {
      return uploadAdapter(loader);
    };
  }

  useEffect(() => {
    getAllCategories();
    defaultData();
  }, [])

  return (
    <Fragment>
      <AddressForm open={open} onClose={() => setOpen(false)} save={(data) => saveAddress(data)} />
      <Box
        sx={{
          borderRadius: "12px",
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{
            background: Colors.primaryGradient,
            p: 2,
            borderRadius: "12px",
          }}
        >
          <Grid item xs={6}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <IconButton onClick={() => navigate(-1)}>
                <KeyboardArrowLeft sx={{ color: Colors.white }} />
              </IconButton>
              <Typography variant="body1" fontWeight="bold" sx={{ color: Colors.white }}>
                Edit AdBook
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage={["Edit AdBook"]} />
          </Grid>
        </Grid>

        <Box sx={{ mt: 3, p: 2, bgcolor: Colors.white, borderRadius: "12px" }}>
          <Grid container spacing={2} component={"form"} onSubmit={handleSubmit(submitForm)}>
            <Grid item md={12}>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "20px", mb: 2 }}>
                <Typography>Status: </Typography>
                <FormControlLabel
                  sx={{
                    m: 0,
                    gap: "10px"
                  }}
                  control={
                    <CustomSwitch
                      checked={isChecked}
                      onChange={handleChecked}
                    />
                  }
                  // disabled={state?.user_id != isAdmin && true}
                  label={<Typography sx={{ width: "60px" }}>{label}</Typography>}
                />
              </Box>
            </Grid>
            <Grid item md={6}>
              <Box>
                <InputField
                  disable={state?.user_id != isAdmin && true}
                  label={"AdBook Title"}
                  register={register("AdBookTitle", {
                    required: "Please enter a title"
                  })}
                  error={errors?.AdBookTitle?.message}
                  helperText={errors?.AdBookTitle?.message}
                />
              </Box>
            </Grid>
            <Grid item md={6}>
              <Box>
                <SelectField
                  disable={state?.user_id != isAdmin && true}
                  data={categories}
                  stateValue={selectedCategory.name}
                  setState={(id, name) => setSelectedCategory({ id: id, name: name })}
                  label={"Categories"}
                  register={register("category", {
                    required: selectedCategory.name == "" ? "Pelase select a category" : false,
                  })}
                  error={errors?.category?.message}
                />
              </Box>
            </Grid>
            <Grid item md={6}>
              <Box
                sx={{
                  height: "126px",
                  border: image !== "" ? "none" : "1px solid rgba(0, 0, 0, 0.23)",
                  borderRadius: "4px",
                  mb: 2,
                  ":hover": {
                    borderColor: image !== "" ? "transparent" : "#1F1F1F"
                  }
                }}
              >
                {image !== "" ? (
                  <Box
                    sx={{
                      display: "flex",
                      // flexDirection: "column-reverse",
                      justifyContent: "center",
                      position: "relative",
                      height: "100%",
                    }}
                  >
                    <CardMedia
                      component={"img"}
                      src={baseUrl + image}
                      sx={{
                        width: "120px",
                        height: "100%",
                        objectFit: "contain"
                      }}
                    />
                    <Box
                      sx={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        display: state?.user_id != isAdmin && "none"
                      }}
                    >
                      <IconButton sx={{ p: 0 }} onClick={() => setImage("")}>
                        <Close sx={{ color: Colors.primary }} />
                      </IconButton>
                    </Box>
                  </Box>
                ) : (
                  <Fragment>
                    <InputLabel
                      htmlFor="image-input"
                      sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px"
                      }}
                    >
                      <PhotoLibrary sx={{ fontSize: "36px" }} />
                      <Typography>
                        Upload Image
                      </Typography>
                    </InputLabel>
                    <input
                      id="image-input"
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleFileUpload(e.target.files[0])}
                      style={{ display: "none" }}
                    />
                  </Fragment>
                )}
              </Box>
            </Grid>
            <Grid item md={6}>
              <Box>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    disabled={state?.user_id != isAdmin && true}
                    value={selectedDate}
                    {...register("date", {
                      required: selectedDate == null ? "Please select a date" : false
                    })}
                    label="Select Date"
                    slotProps={{
                      textField: {
                        fullWidth: true
                      }
                    }}
                    onChange={(date) => handleDateChange(date)}
                  />
                  <FormHelperText sx={{ color: errors?.date && Colors.danger }}>
                    {errors?.date?.message}
                  </FormHelperText>
                </LocalizationProvider>
              </Box>
            </Grid>
            <Grid item md={12}>
              <Box>
                <div className="App">
                  <CKEditor
                    disabled={state?.user_id != isAdmin && true}
                    editor={ClassicEditor}
                    config={{
                      extraPlugins: [uploadPlugin],
                      mediaEmbed: {
                        previewsInData: true,
                        extraProviders: [
                          {
                            name: "allow-all",
                            url: /^.+/,
                            html: (match) => `
                            <div style="background: #0f0f0f; height: 519px; display: flex; align-items: center; justify-content: center;" class="ck-media__wrapper" data-oembed-url="${match[0]}">
                              <div class="ck ck-reset_all ck-media__placeholder">
                                <div class="ck-media__placeholder__icon">
                                  <a style="color: white; text-align: center;" class="ck-media__placeholder__url" target="new" href="${match[0]}">
                                  <svg fill="#ffffff" height="80px" width="80px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-1 -1 62 62" xml:space="preserve" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M45.563,29.174l-22-15c-0.307-0.208-0.703-0.231-1.031-0.058C22.205,14.289,22,14.629,22,15v30 c0,0.371,0.205,0.711,0.533,0.884C22.679,45.962,22.84,46,23,46c0.197,0,0.394-0.059,0.563-0.174l22-15 C45.836,30.64,46,30.331,46,30S45.836,29.36,45.563,29.174z M24,43.107V16.893L43.225,30L24,43.107z"></path> <path d="M30,0C13.458,0,0,13.458,0,30s13.458,30,30,30s30-13.458,30-30S46.542,0,30,0z M30,58C14.561,58,2,45.439,2,30 S14.561,2,30,2s28,12.561,28,28S45.439,58,30,58z"></path> </g> </g></svg>
                                  </a>
                                </div>
                              </div>
                            </div>
                            `
                          }
                        ],
                      }
                    }}
                    data={state?.content}
                    onReady={(editor) => handleEditorReady(editor)}
                    onBlur={(event, editor) => handleEditorChange(event, editor)}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setCkValue(data);
                    }}
                  />
                </div>
              </Box>
            </Grid>
            <Grid item md={6}>
              <Box>
                <InputField
                  disable={state?.user_id != isAdmin && true}
                  label={"Contact Person"}
                  register={register("contactPerson", {
                    required: "Please enter a name"
                  })}
                  error={errors?.contactPerson?.message}
                  helperText={errors?.contactPerson?.message}
                />
              </Box>
            </Grid>
            <Grid item md={6}>
              <Box>
                <InputField
                  disable={state?.user_id != isAdmin && true}
                  label={"Email"}
                  register={register("email", {
                    required: "Please enter an email"
                  })}
                  error={errors?.email?.message}
                  helperText={errors?.email?.message}
                />
              </Box>
            </Grid>
            <Grid item md={6}>
              <Box>
                <InputField
                  disable={state?.user_id != isAdmin && true}
                  label={"Phone"}
                  register={register("phone", {
                    required: "Please enter a phone number"
                  })}
                  error={errors?.phone?.message}
                  helperText={errors?.phone?.message}
                />
              </Box>
            </Grid>
            <Grid item md={6}>
              <Box>
                <TextField
                  disabled={state?.user_id != isAdmin && true}
                  {...register("address", {
                    required: "Please select a location"
                  })}
                  onClick={() => setOpen(true)}
                  fullWidth
                  label={addressData?.address ? null : "Address"}
                  InputProps={{ readOnly: true }}
                  value={addressData?.address}
                  error={errors?.address && true}
                  helperText={errors?.address?.message}
                />
              </Box>
            </Grid>
            {/* <Grid item md={12} sx={{ mt: "10px" }}>
              <Grid container spacing={2}>
                <Grid item md={4}>
                  <Box>
                    <TextField
                      disabled={state?.user_id != isAdmin && true}
                      select
                      fullWidth
                      label={"Social Platform"}
                      {...register("socialP", {
                        onChange: (e) => handleSocialPlatform(e.target.value)
                      })}
                      error={errors?.socialP?.message}
                      helperText={errors?.socialP?.message}
                    >
                      {socialData.map((item, i) => (
                        <MenuItem key={i} value={item.value}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Box>
                </Grid>
                {selectedSocial.name !== "" && (
                  <Grid item md={7}>
                    <Box>
                      <InputField
                        label={`${selectedSocial?.name} Link`}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position='start'>
                              {selectedSocial?.icon}
                            </InputAdornment>
                          )
                        }}
                        register={register(selectedSocial?.name)}
                        value={link}
                        onChange={(e) => setLink(e.target.value)}
                        error={errors?.[selectedSocial?.name]?.message}
                        helperText={errors?.[selectedSocial?.name]?.message}
                      />
                    </Box>
                  </Grid>
                )}
                {selectedSocial.name !== "" && (
                  <Grid item md={1}>
                    <Box>
                      <Button onClick={() => handleLinkAdd()} variant={"outlined"}>Add</Button>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Grid>
            <Grid item md={12}>
              <Grid container spacing={2} sx={{ mt: "10px" }}>
                {socialMediaLink.length > 0 && socialMediaLink?.map((item, i) => {
                  if (item?.f_link) {
                    return (
                      <Grid item md={12}>
                        <Box key={i} sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <Typography>
                            <Box
                              sx={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "center"
                              }}
                            >
                              <FacebookRounded sx={{ color: Colors.primary }} />
                              <Typography>{item?.f_link}</Typography>
                              <IconButton
                                onClick={() => handleRemoveLink(item)}
                              >
                                <Close sx={{ fontSize: "16px", color: Colors.primary }} />
                              </IconButton>
                            </Box>
                          </Typography>
                        </Box>
                      </Grid>
                    )
                  }
                  if (item?.t_link) {
                    return (
                      <Grid item md={12}>
                        <Box key={i} sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <Typography>
                            <Box
                              sx={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "center"
                              }}
                            >
                              <X sx={{ color: Colors.primary }} />
                              <Typography>{item?.t_link}</Typography>
                              <IconButton
                                onClick={() => handleRemoveLink(item)}
                              >
                                <Close sx={{ fontSize: "16px", color: Colors.primary }} />
                              </IconButton>
                            </Box>
                          </Typography>
                        </Box>
                      </Grid>
                    )
                  }
                  if (item?.l_link) {
                    return (
                      <Grid item md={12}>
                        <Box key={i} sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <Typography>
                            <Box
                              sx={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "center"
                              }}
                            >
                              <LinkedIn sx={{ color: Colors.primary }} />
                              <Typography>{item?.l_link}</Typography>
                              <IconButton
                                onClick={() => handleRemoveLink(item)}
                              >
                                <Close sx={{ fontSize: "16px", color: Colors.primary }} />
                              </IconButton>
                            </Box>
                          </Typography>
                        </Box>
                      </Grid>
                    )
                  }
                  if (item?.w_link) {
                    return (
                      <Grid item md={12}>
                        <Box key={i} sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <Typography>
                            <Box
                              sx={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "center"
                              }}
                            >
                              <Instagram sx={{ color: Colors.primary }} />
                              <Typography>{item?.w_link}</Typography>
                              <IconButton
                                onClick={() => handleRemoveLink(item)}
                              >
                                <Close sx={{ fontSize: "16px", color: Colors.primary }} />
                              </IconButton>
                            </Box>
                          </Typography>
                        </Box>
                      </Grid>
                    )
                  }
                })}
              </Grid>
            </Grid> */}
            <Grid item md={12}>
              <Box
                sx={{
                  mt: 2,
                  display: "flex",
                  justifyContent: "flex-end"
                }}
              >
                <PrimaryButton
                  // disabled={state?.user_id != isAdmin && true}
                  title={"Submit"}
                  type={"submit"}
                  loading={loading}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Fragment >
  )
}

export default EditAdBook